import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useEffect } from 'react';
import MerkAdmin from './merkadmin/merkadmin';
import Dashboard from './dashboard/dashboard';
import Merk from './merk/merk';
import SpanAdmin from './spanadmin/spanadmin';
import Beoordelaars from './beoordelaars/beoordelaars';
import Rondtes from './rondtes/rondtes';
import Spanne from './spanne/spanne';
import Borge from './borge/borge';
import Landing from './landing/landing';
import { usePulsy } from 'pulsy';
import { validateToken, logout } from './auth/authService';
import './auth/authStore';
import Login from './login/login';
import Aanmeld from './login/aanmeld';
import logo from "./logo.svg"

function NavBar(){

  const path = window.location.pathname.replace(/^\//, "");

  function route(naam){
    window.location.href = "/" + naam;
  }

  function handleLogout(){
    logout();
    window.location.href = "/login";
  }

  const items = [
    { naam: "oorsig", label: "Oorsig" },
    { naam: "merkadmin", label: "Kriteria" },
    { naam: "rondtes", label: "Rondtes" },
    { naam: "spanadmin", label: "Span Bestuur" },
    { naam: "spanne", label: "Spanne" },
    { naam: "beoordelaars", label: "Beoordelaars" },
    { naam: "borge", label: "Borge" },
  ];

  return  (
    <div className="appbar">
      <div className="appbar-brand" onClick={() => route("oorsig")}>
        <img src={logo} alt="Melktert" />
      </div>
      <nav className="appbar-nav">
        {items.map(item => (
          <button
            key={item.naam}
            type="button"
            className={"nav-item" + (path === item.naam ? " is-active" : "")}
            onClick={() => route(item.naam)}
          >
            {item.label}
          </button>
        ))}
      </nav>
      <button type="button" className="nav-item nav-logout appbar-logout" onClick={handleLogout}>
        Teken Uit
      </button>
    </div>
  );
}

function BeoordelaarHeader(){
  const path = window.location.pathname.replace(/^\//, "");

  function route(naam){
    window.location.href = "/" + naam;
  }

  function handleLogout(){
    logout();
    window.location.href = "/login";
  }

  const items = [
    { naam: "tuis", label: "Tuis" },
    { naam: "merk", label: "Merk" },
    { naam: "spanne", label: "Spanne" },
  ];

  return (
    <div className="judge-header">
      <div className="judge-brand">
        <img src={logo} alt="Melktert" />
      </div>
      <nav className="appbar-nav">
        {items.map(item => (
          <button
            key={item.naam}
            type="button"
            className={"nav-item" + (path === item.naam ? " is-active" : "")}
            onClick={() => route(item.naam)}
          >
            {item.label}
          </button>
        ))}
      </nav>
      <button type="button" className="nav-item nav-logout" onClick={handleLogout}>
        Teken Uit
      </button>
    </div>
  );
}



function App() {
  const [auth] = usePulsy('auth');

  useEffect(() => {
    // Check token validity on app load
    if (auth.token) {
      validateToken();
    }
  }, [auth.token]);

  // Redirect away from login if already authenticated
  useEffect(() => {
    if (auth.user && window.location.pathname === '/login') {
      window.location.href = '/';
    }
  }, [auth.user, auth.role]);

  // Signing in from the QR code on the printed sheet works whether or not someone is signed in
  if (window.location.pathname === '/aanmeld') {
    return (
      <div className="App">
        <Aanmeld />
      </div>
    );
  }

  return (
    <div className="App">
      {!auth.user ? (
        <Login />
      ) : auth.role === 'admin' ? (
        <Router>
          <NavBar></NavBar>
          <div className="main-content with-navbar">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/oorsig" element={<Dashboard />} />
              <Route path="/merkadmin" element={<MerkAdmin />} />
              {/* <Route path="/merk" element={<Merk />} /> */}
              <Route path="/spanadmin" element={<SpanAdmin />} />
              <Route path="/spanne" element={<Spanne />} />
              <Route path="/beoordelaars" element={<Beoordelaars />} />
              <Route path="/rondtes" element={<Rondtes />} />
              <Route path="/borge" element={<Borge />} />
              <Route path="/tuis" element={<Landing />} />
              <Route path="/" element={<Dashboard />} />
            </Routes>
          </div>
        </Router>
      ) : (
        <Router>
          <BeoordelaarHeader />
          <div className="main-content">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/tuis" element={<Landing />} />
              <Route path="/merk" element={<Merk />} />
              <Route path="/spanne" element={<Spanne />} />
              <Route path="/" element={<Landing />} />
            </Routes>
          </div>
        </Router>
      )}
    </div>
  );
}

export default App;
